$(document).ready(function(){
  const checkElement = async selector => {
    while ( document.querySelector(selector) === null) {
      await new Promise( resolve =>  requestAnimationFrame(resolve) )
    }
    return document.querySelector(selector); 
    };
    
  setTimeout(() => {
      const queryParams = window.location.search.split('=').length;
      if(queryParams == 1){
      $('.js-sorting-select').append(`<option selected disabled hidden value="Sort By +">Sort By +</option>`);
      }
      $('.empty_slot_banner__wrapper').css('min-height', $(".product-grid-item").height() )
  }, 300)



    $('ul.touch__nav__links > li .nav-link').on('click', function(e){
       // e.preventDefault();
      
        // $(this).next('.nav-carat').trigger('click');
        // const iconSelector = $(this).next();
        // console.log(iconSelector.attr('aria-expanded'))
    });


    $('.header__hamburger').on('click', function(){
        $('body').toggleClass('nav-open')
    })

    $('.js-empty-recs-slider').slick({
        infinite: true,
        centerMode: true,
        centerPadding: '100px',
        slidesToShow: 1,
        mobileFirst: true,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToScroll: 5,
                centerMode: false,
                slidesToShow: 5,
                draggable: true
              }
            }
          ]
    });
    setTimeout(() => {
        $('.js-recs-slider').show()
        $('.js-recs-slider').slick({
            infinite: true,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1,
            mobileFirst: true,
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToScroll: 2,
                    centerMode: false,
                    slidesToShow: 2,
                    draggable: true
                  }
                },
                {
                    breakpoint: 1024,
                    settings: {
                      slidesToScroll: 3,
                      centerMode: false,
                      slidesToShow: 3,
                      draggable: true
                    }
                  }
              ]
        });  

    },600)

    $(document).on('click', '.js-quick-add' , function() {
        const id = $(this).data('product')
        $.post(window.Shopify.routes.root + 'cart/add.js', {
            'items': [{
                'id': id,
                'quantity': 1                
                }]
        }).done(function(){
            location.reload()
        })
    });

    $('.js-subscription-btn').on('click', function(){
        const plan_id = $(this).data('value');
        const variant_id = $(this).data('variant');
        const item_idx = $(this).data('idx');
        
        $.post(window.Shopify.routes.root + 'cart/change.js', {            
          'line': item_idx,
          'quantity': 0         
        }).done(function() {
          $.post(window.Shopify.routes.root + 'cart/add.js', {
            'items': [{
                'id': variant_id,
                'quantity': 1,
                'selling_plan': plan_id,
                }]
          }).done(function() {
            setTimeout(() => {
              location.reload()
            }, 700)           
            })

        });


    
    });
    /*Homepage Press Slider*/
    $('.js-press-slider').slick({
        dots: true,
        centerMode: true,
        centerPadding: '0px',
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000
    });
     /*Homepage Product Slider*/
    $('.js-product-slider').slick({
        infinite: true,
        centerMode: true,
        centerPadding: '70px',
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        arrows: false,
        responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToScroll: 3,
                centerMode: false,
                slidesToShow: 3,
                draggable: true
              }
            },
            {
                breakpoint: 1023,
                settings: {
                  slidesToScroll: 5,
                  centerMode: false,
                  slidesToShow: 5,
                  draggable: true
                }
              }
          ]
    });
    /*Homepage reviews slider*/
    $('.js-reviews-slider').slick(
      {
        dots: true,
        centerMode: true,
        centerPadding: '0px',
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000
      }
    )
    /*Homepage Instafeed slider*/
    $('.js-instafeed-slider').slick({
      infinite: true,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: false,
      responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToScroll: 3,
              centerMode: false,
              slidesToShow: 3,
              draggable: true
            }
          },
          {
              breakpoint: 1023,
              settings: {
                slidesToScroll: 5,
                centerMode: false,
                slidesToShow: 5,
                draggable: true
              }
            }
        ]
    });

    $('.js-collection-filters').slick({
      infinite: false,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 2,
      mobileFirst: true,
      arrows: false,
      dots: false,
      autoplay: false,
      variableWidth: true,
      responsive: [
          {
            breakpoint: 821,
            settings: {
              settings: "unslick"
            }
          }
        ]
    })

    $('[name="skio-one-time"]').on('click', function(){
      $('[data-skio-style]').removeAttr('data-skio-style');
      $(this).attr('data-skio-style', true)
    })
    $('[name="skio-subscription"]').on('click', function(){
      $('[data-skio-style]').removeAttr('data-skio-style');
      $(this).attr('data-skio-style', true)
    })
    $('.product__description .accordion-title').on('click', function(){
      $('.accordion-open').slideUp().removeClass('accordion-open');
      $('.accordion-title-open').removeClass('accordion-title-open');
      if($(this).next().is(':hidden')){
        $(this).addClass('accordion-title-open')
        $(this).next('.accordion-panel').addClass('accordion-open').slideDown();
      }else{
        $(this).next().slideUp();
        $(this).removeClass('accordion-title-open');
      }
    });

    if ($('body.template-product').length) {
    checkElement('.rc-option__text').then((selector) => {
      $('.rc-option__subsave .rc-option__discount').prepend('<span>SAVE </span>')
      $('.rc-selling-plans__dropdown').before('<span>Deliver </span>')
      $('.rc-selling-plans__dropdown').after('<span class="chevron-down"></span>')
    });
    }
   

    // if(document.querySelector('.template-product')){
    //   const stickyATC = function(){
    //     const regularBtn = document.querySelector('.regular-btn');
       
    //     if(window.scrollY > regularBtn.offsetTop - 500){
    //       document.querySelector('.js-sticky-atc').classList.add('show-btn');
    //     }else{
    //       document.querySelector('.js-sticky-atc').classList.remove('show-btn');
    //     }
    //   }
    //   window.addEventListener('scroll', stickyATC);
      
    //     // PDP Sticky ATC
    //     let atcBtn = document.querySelector('.sticy-atc');
    //     atcBtn.addEventListener('click', () => {
    //     document.querySelector('button.add-to-cart').click()
    //     });

    // }

});
